import './App.css';
import AdminPage from './component/AdminPage';
import HomePage from './component/HomePage';

function App() {
  const isAdminRoute = window.location.pathname.replace(/\/$/, '') === '/admin';

  return (
    isAdminRoute ? <AdminPage /> : <HomePage />
  );
}

export default App;
